import Axios from "axios";
import {initProfileForm} from "./form";
import {loading, stopLoading} from "../helpers/loading";
import {handleAjaxSuccess} from "../helpers/swalHelper";
import handleAjaxError from "../helpers/handleAjaxError";

function initProfileEdit() {
	const profileForm = initProfileForm(document.querySelector('.profile-form'));

	document.querySelector('.update-profile-button').onclick = updateProfile;

	function updateProfile() {
		const userData = profileForm.inputs();

		profileForm.clearFeedbacks();

		loading();

		Axios.post(profileForm.postUrl(), userData)
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading)
	}
}

export {initProfileEdit}
